import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { LiveDot } from '@sorare/core/src/components/live/LiveDot';

import { Status } from 'components/managerTeam/Status';

import {
  ManagerTeamBadge_managerTeam,
  ManagerTeamBadge_so5Leaderboard,
  ManagerTeamBadge_so5Ranking,
} from './__generated__/index.graphql';
import incomplete from './assets/incomplete.svg';
import validated from './assets/validated.svg';

const Img = styled.div`
  display: inline-flex;
  position: relative;
  border-radius: unset;
`;
const Dot = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  border: 2px solid var(--c-neutral-200);
  border-radius: 50%;
`;
const StatusWrapper = styled.div`
  position: absolute;
  right: calc(-1 * var(--half-unit));
  top: calc(-1 * var(--half-unit));
  width: var(--double-unit);
  height: var(--double-unit);
  * {
    max-width: 100%;
    max-height: 100%;
  }
`;
type Props = {
  hasLiveGames: boolean;
  managerTeam?: Nullable<ManagerTeamBadge_managerTeam>;
  ranking?: ManagerTeamBadge_so5Ranking;
  leaderboard: Nullable<ManagerTeamBadge_so5Leaderboard>;
  validLineup: boolean;
  fixtureStarted?: boolean;
};
export const Badge = ({
  hasLiveGames,
  managerTeam,
  ranking,
  leaderboard,
  validLineup,
  fixtureStarted,
}: Props) => {
  return (
    <Img>
      {hasLiveGames && (
        <Dot>
          <LiveDot animate />
        </Dot>
      )}
      <img
        src={
          leaderboard?.iconUrl ||
          managerTeam?.activeDivisionIconUrl ||
          `https://frontend-assets.sorare.com/football/manager_team/${
            leaderboard?.mainRarityType || 'academy'
          }/icon.png`
        }
        alt=""
        width="40px"
        height="40px"
      />
      {ranking || fixtureStarted ? (
        <StatusWrapper>
          <Status ranking={ranking} />
        </StatusWrapper>
      ) : (
        <StatusWrapper>
          {validLineup ? (
            <img src={validated} alt="" />
          ) : (
            <img src={incomplete} alt="" />
          )}
        </StatusWrapper>
      )}
    </Img>
  );
};

Badge.fragments = {
  so5Leaderboard: gql`
    fragment ManagerTeamBadge_so5Leaderboard on So5Leaderboard {
      slug
      mainRarityType
      iconUrl
    }
  ` as TypedDocumentNode<ManagerTeamBadge_so5Leaderboard>,
  so5Ranking: gql`
    fragment ManagerTeamBadge_so5Ranking on So5Ranking {
      id
      ...Status_so5Ranking
    }
    ${Status.fragments.so5Ranking}
  ` as TypedDocumentNode<ManagerTeamBadge_so5Ranking>,
  managerTeam: gql`
    fragment ManagerTeamBadge_managerTeam on ManagerTeam {
      id
      activeDivisionIconUrl
      mainRarityType
    }
  ` as TypedDocumentNode<ManagerTeamBadge_managerTeam>,
};
